import { useTranslation } from 'react-i18next';
import { usePlatformSettings } from '@/hooks';

export function WhatsAppBubble() {
  const { t } = useTranslation('common');
  const { data: settings } = usePlatformSettings();

  if (!settings?.whatsappNumber || !settings?.whatsappEnabled) return null;

  const cleanNumber = settings.whatsappNumber.replace(/\D/g, '');
  const message = settings.whatsappMessage
    ? `?text=${encodeURIComponent(settings.whatsappMessage)}`
    : '';

  return (
    <a
      href={`https://wa.me/${cleanNumber}${message}`}
      target="_blank"
      rel="noopener noreferrer"
      className="group fixed bottom-4 right-4 z-50 sm:bottom-8 sm:right-8 lg:bottom-10 lg:right-8"
      aria-label={t('whatsApp.ariaLabel')}
    >
      <div className="relative">
        {/* Pulse ring */}
        <div className="absolute inset-0 animate-ping rounded-full bg-[#25D366] opacity-25" />

        {/* Button */}
        <div className="relative flex h-12 w-12 cursor-pointer items-center justify-center rounded-full bg-[#25D366] shadow-lg transition-all duration-300 hover:scale-110 hover:shadow-xl sm:h-14 sm:w-14">
          {/* WhatsApp SVG Icon */}
          <svg viewBox="0 0 32 32" fill="white" className="h-7 w-7">
            <path d="M16.004 0h-.008C7.174 0 0 7.176 0 16c0 3.5 1.128 6.744 3.046 9.378L1.054 31.29l6.118-1.958C9.72 30.876 12.742 32 16.004 32 24.826 32 32 24.822 32 16S24.826 0 16.004 0zm9.335 22.594c-.39 1.098-1.924 2.01-3.164 2.276-.852.18-1.962.322-5.702-1.226-4.786-1.98-7.864-6.834-8.104-7.15-.228-.316-1.916-2.55-1.916-4.862 0-2.312 1.212-3.45 1.642-3.922.39-.428 1.022-.62 1.628-.62.196 0 .372.01.53.018.468.02.704.048 1.012.782.388.92 1.332 3.232 1.448 3.468.118.236.196.51.04.816-.148.31-.224.502-.446.774-.224.272-.47.608-.67.814-.224.232-.456.482-.196.944.26.46 1.158 1.916 2.486 3.104 1.706 1.526 3.144 1.998 3.59 2.22.348.174.762.136 1.032-.156.342-.368.762-.978 1.19-1.582.306-.432.69-.486 1.072-.332.388.148 2.456 1.158 2.876 1.37.42.21.698.316.8.49.102.174.102 1.004-.288 2.102z" />
          </svg>
        </div>

        {/* Tooltip */}
        <div className="pointer-events-none absolute bottom-full right-0 mb-3 opacity-0 transition-opacity duration-200 group-hover:opacity-100">
          <div className="whitespace-nowrap rounded-lg border border-border/50 bg-card px-3 py-2 text-sm font-medium shadow-lg">
            {t('whatsApp.tooltip')}
            <div className="absolute right-5 top-full h-2 w-2 -translate-y-1 rotate-45 transform border-b border-r border-border/50 bg-card" />
          </div>
        </div>
      </div>
    </a>
  );
}
